import { useContext } from "react";
import { HookOutOfContextError } from "../errors";
import { AppVariantContext } from "../providers/AppVariantProvider";

export const useAppVariant = () => {
  const context = useContext(AppVariantContext);

  if (!context) {
    throw new HookOutOfContextError("useAppVariant", "AppVariantContext");
  }
  const { variant, isDemo, version, setVersion } = context;

  return {
    variant,
    isMobile: variant === "mobile",
    isWeb: variant === "web",
    isDemo,
    version,
    setVersion,
    isCx: version === "cx",
    isGeneral: version === "general",
  };
};
